const inkeep_ai_bot = {
    intro_message: '你好，我是 Logto AI！\n\n 我是訓練於文檔、幫助文章以及其他內容的 AI 助手。\n\n 你可以問我任何關於 Logto 的問題。',
    chat_placeholder: '向 Logto AI 詢問你的問題以獲得逐步指南',
    disclaimer_label: 'Logto AI 免責聲明',
    disclaimer_tooltip: '回覆內容由 AI 生成，可能需要進一步核實。',
    example_questions_label: '示例問題',
    example_questions: ['Logto 設置的快速指南', '配置多租戶架構', '如何整合用戶資料？'],
    stop: '停止',
    clear: '重新開始',
    get_help: '獲得幫助',
    copy_chat: '複製',
    ask_ai_label: '詢問 AI',
    contact: '聯絡我們',
    discord: 'Discord 社群',
};
export default Object.freeze(inkeep_ai_bot);
